module.exports = __webpack_public_path__ + "img/end-and-side-tables.3a06dec.png";